import { TextAreaTemplate } from '@templates';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../routes/Routes';
import { useState } from 'react';
import { useHighwaysStore } from '@highways/store/store';
import { ErrorMessages } from '@types';
import { parseZodErrors } from '@highways/utils/zod-validations';
import { textAreaInputSchema } from '@highways/utils/validations';
import { ANYTHING_ELSE_ERROR } from '@highways/constants/errorMessages';
import { ZodError } from 'zod';
import { scrollTop } from '@utils';

export const AnythingElseWeShouldKnowPage = () => {
  const { updateAnythingElseText, anythingElseText } = useHighwaysStore();
  const [textInput, setTextInput] = useState(anythingElseText);
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const navigate = useNavigate();
  const MAX_LENGTH = 500;
  const pageTitle = 'Tell us more about the location of the damage';
  const description = `Include landmarks and building numbers, for example "outside the telephone box opposite Westminster City Council, 64 Victoria Street".`;

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextInput(event.target.value);
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      try {
        const validatedData = textAreaInputSchema({
          fieldName: 'anythingElseText',
          requiredMessage: ANYTHING_ELSE_ERROR.required.message,
          maxLength: MAX_LENGTH,
          maxLengthMessage: ANYTHING_ELSE_ERROR.maxLength.message,
        }).parse({
          anythingElseText: textInput,
        });
        if (validatedData.anythingElseText) {
          updateAnythingElseText(validatedData.anythingElseText);
        }
        navigate(RoutesList.EMAIL_CONFIRMATION_REPORT);
        scrollTop();
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.ISSUE_LOCATION);
      scrollTop();
    },
  };

  return (
    <TextAreaTemplate
      initialTextValue={textInput}
      labelText={pageTitle}
      description={description}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      maxLength={500}
      errorPath={'anythingElseText'}
      errorMessages={errorMessages}
    />
  );
};
